import { render, staticRenderFns } from "./CustomersCreationsIndicator.vue?vue&type=template&id=76359645&scoped=true"
import script from "./CustomersCreationsIndicator.vue?vue&type=script&lang=js"
export * from "./CustomersCreationsIndicator.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76359645",
  null
  
)

export default component.exports